export default function EmailTestPageRemoved() {
  return null;
}
